import { SearchDate } from './SearchDate'
import { withSearchDate } from './withSearchDate'

const Connected = withSearchDate(SearchDate)

export { Connected as SearchDate }
